// extracted by mini-css-extract-plugin
export default {"wrapper":"SupportedManufacturersField_wrapper__y80up","unknownManufacturer":"SupportedManufacturersField_unknownManufacturer__UWKP7"};